var XPortal = XPortal || {};

// Record navigator block: steps through the rows of the grid living in the same
// xGridPageSection and loads each record's detail exactly as a manual row click does.
//
// NOTE: these grids do NOT use Kendo's native row selection for the "current" row -
// the selected row is marked with the .k-state-selected class and the record is read
// from the grid dataSource via XPortal.Template.GetObjPropValueByName. We therefore
// resolve the current/target record through the grid helpers (GetGridDataRowItem /
// GetGridRowsByUid) and re-fire the same chain a manual click produces
// (parent.changed.updateSelected) so EntityDetailBlock reloads the in-page detail.
XPortal.RecordNavigator = (function () {
    var self = {
        Init: function (container) {
            $(container ? container : "body").find(".record-navigator").each(function () {
                initFor($(this));
            });
        }
    };

    function recordUid(item) {
        return XPortal.Template.GetObjPropValueByName(item, "uid");
    }

    function initFor($nav) {
        if ($nav.attr("data-rn-processed") === "1") return;

        var $grid = findGrid($nav);
        if (!$grid.length) return; // no grid in this section - nothing to navigate

        $nav.attr("data-rn-processed", "1");

        XPortal.Utils.waitFor(function () {
            if (!$grid.data("kendoGrid")) return false; // keep waiting until the grid is initialized
            bindEvents($nav, $grid);
            return true;
        }, XPortal.Utils.waitFor, 100, 100);
    }

    function bindEvents($nav, $grid) {
        $nav.on("click", ".record-navigator__btn--prev", function () {
            if (!$(this).is(":disabled")) step($nav, $grid, -1);
        });
        $nav.on("click", ".record-navigator__btn--next", function () {
            if (!$(this).is(":disabled")) step($nav, $grid, 1);
        });

        // keep the content and button states in sync whenever the navigable records change
        var kgrid = $grid.data("kendoGrid");
        kgrid.bind("parent.changed.updateSelected", function () {
            refresh($nav, $grid);
        });
        kgrid.bind("dataBound", function () {
            refresh($nav, $grid);
        });
        $grid.on("click", ".row-checkbox", function () {
            setTimeout(function () { refresh($nav, $grid); }, 0);
        });

        refresh($nav, $grid);
    }

    function flattenGroups(items) {
        var out = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item && item.field !== undefined && item.items) out = out.concat(flattenGroups(item.items));
            else out.push(item);
        }
        return out;
    }

    function pageRecords(ginfo) {
        return flattenGroups((ginfo.kgrid.dataSource.view() || []).slice());
    }

    function getCheckedUids(ginfo) {
        var uids = [];
        XPortal.GridActions.GetXSelectedRows(ginfo.grid, false, uids);
        return _.uniq(uids);
    }

    function getNavigationScope(ginfo) {
        var view = pageRecords(ginfo);
        var uids = view.length ? getCheckedUids(ginfo) : [];

        if (!uids.length) return { items: view, selection: false };

        var items = view.filter(function (item) {
            return uids.indexOf(String(recordUid(item)).toLowerCase()) >= 0;
        });
        return { items: items, selection: true };
    }

    // The records in play plus the index of the current one within them (-1 when there is none).
    function getCurrentPosition(ginfo) {
        var scope = getNavigationScope(ginfo);
        var view = pageRecords(ginfo);
        var current = scope.items.length ? getCurrentRecord(ginfo) : null;

        if (current && indexOfRecord(view, current) < 0) current = null;

        return {
            scope: scope,
            current: current,
            idx: current ? indexOfRecord(scope.items, current) : -1
        };
    }

    function neighbourInScope(ginfo, scope, current, dir) {
        var view = pageRecords(ginfo);
        var order = {};
        for (var v = 0; v < view.length; v++) order[recordUid(view[v])] = v;

        var at = order[recordUid(current)];
        if (at === undefined) return -1;

        var before = -1;
        for (var i = 0; i < scope.items.length; i++) {
            var vi = order[recordUid(scope.items[i])];
            if (vi === undefined) continue;
            if (dir > 0) {
                if (vi > at) return i;
            } else if (vi < at) {
                before = i;
            }
        }
        return dir > 0 ? -1 : before;
    }

    function step($nav, $grid, dir) {
        var ginfo = XPortal.Grid.GetGridInfo($grid);
        var position = getCurrentPosition(ginfo);
        var scope = position.scope;
        if (!scope.items.length) return;

        var idx = position.idx;
        var target = idx >= 0
            ? idx + dir
            : (position.current
                ? neighbourInScope(ginfo, scope, position.current, dir)
                : (dir < 0 ? scope.items.length - 1 : 0));

        if (scope.items[target]) {
            selectRecord(ginfo, scope.items[target], scope.selection);
            refresh($nav, $grid);
            return;
        }

        if (scope.selection) return;

        // ran past the end of this page's records - carry on into the adjacent page
        var ds = ginfo.kgrid.dataSource;
        var page = ds.page() || 1;
        if (dir > 0 && page < getPageCount(ds)) goToPage($nav, $grid, page + 1, "first");
        else if (dir < 0 && page > 1) goToPage($nav, $grid, page - 1, "last");
    }

    // edge is the end of the new page to land on: "first" going forwards, "last" going back.
    function goToPage($nav, $grid, targetPage, edge) {
        $grid.data("kendoGrid").dataSource.page(targetPage);

        // Wait for the page read AND the grid's own refresh (content view / editor dropdowns)
        // to fully settle before we touch the selection. Selecting mid-refresh races with the
        // grid re-initializing its dropdown editors and throws "before it is initialized".
        XPortal.Utils.waitFor(function () {
            var kgrid = $grid.data("kendoGrid");
            var ds = kgrid && kgrid.dataSource;
            if (!ds || ds._requestInProgress || ds.page() !== targetPage || !ds.view()) return false;

            var ginfo = XPortal.Grid.GetGridInfo($grid);
            var scope = getNavigationScope(ginfo);
            if (scope.items.length) {
                selectRecord(ginfo, scope.items[edge === "last" ? scope.items.length - 1 : 0], scope.selection);
                refresh($nav, $grid);
            }
            return true;
        }, XPortal.Utils.waitFor, 50, 200);
    }

    // Select a record the same way a manual row click does, so the detail block reloads.
    function selectRecord(ginfo, item, selectionMode) {
        var kgrid = ginfo.kgrid;
        var uid = recordUid(item);
        if (uid == null) return;

        try {
            // gather the row element(s) for this record (locked + unlocked tables)
            var $rows = $();
            (XPortal.Grid.GetGridRowsByUid(ginfo.grid, uid, true, []) || []).forEach(function (r) {
                $rows = $rows.add(r);
            });

            // move the current-row highlight
            ginfo.grid.find("tr.k-state-selected").removeClass("k-state-selected");
            $rows.addClass("k-state-selected");

            // keep Kendo's own selection in sync with the content (non-locked) row
            var $contentRow = kgrid.tbody ? kgrid.tbody.find("tr[data-uid='" + uid + "']") : $rows.filter("tr").last();
            if ($contentRow.length) kgrid.select($contentRow);

            // remember the current selection
            if (!selectionMode) ginfo.grid.data("lastCheckedRows", [XPortal.Grid.DataUniqueId(item)]);

            // EntityDetailBlock listens to this to reload the in-page detail for the selected row
            kgrid.trigger("parent.changed.updateSelected");
        } catch (e) {
            console.warn("RecordNavigator: select failed", e);
        }
    }

    function refresh($nav, $grid) {
        var ginfo = XPortal.Grid.GetGridInfo($grid);
        var position = getCurrentPosition(ginfo);
        var record = position.idx < 0 ? position.current : position.scope.items[position.idx];

        setButtonsState($nav, !canStep(ginfo, position, -1), !canStep(ginfo, position, 1));
        renderContent($nav, record, record ? getNavigationInfo(ginfo, position.scope, position.idx) : null);
        $nav.toggleClass("d-none", !record);
    }

    function canStep(ginfo, position, dir) {
        var scope = position.scope;
        if (!scope.items.length) return false;

        if (position.idx < 0) {
            return !position.current || neighbourInScope(ginfo, scope, position.current, dir) >= 0;
        }

        var next = position.idx + dir;
        if (next >= 0 && next < scope.items.length) return true;

        if (scope.selection) return false;

        var ds = ginfo.kgrid.dataSource;
        var page = ds.page() || 1;
        return dir > 0 ? page < getPageCount(ds) : page > 1;
    }

    function setButtonsState($nav, prevDisabled, nextDisabled) {
        $nav.find(".record-navigator__btn--prev").prop("disabled", prevDisabled);
        $nav.find(".record-navigator__btn--next").prop("disabled", nextDisabled);
    }

    // Position/total for the content template: within the checked rows, or the whole list.
    function getNavigationInfo(ginfo, scope, idx) {
        var ds = ginfo.kgrid.dataSource;

        if (scope.selection) {
            return { NavIsSelection: true, NavPosition: idx < 0 ? 0 : idx + 1, NavTotal: scope.items.length };
        }

        var pageSize = ds.pageSize() || scope.items.length;
        return {
            NavIsSelection: false,
            NavPosition: idx < 0 ? 0 : ((ds.page() || 1) - 1) * pageSize + idx + 1,
            NavTotal: ds.total() || scope.items.length
        };
    }

    function renderContent($nav, item, info) {
        $nav.find(".record-navigator__content")
            .html(item ? applyTemplate($nav.attr("data-content-tmpl"), item, info, $nav.attr("data-nid")) : "");
    }

    // Resolve [[FieldAlias]] placeholders and #= ... # functions against the selected record.
    function applyTemplate(template, item, info, nodeId) {
        if (!template) return "";
        var model = $.extend({}, item.toJSON(), info);
        return XPortal.Format.ProcessTemplate(template, null, model, nodeId, "-");
    }

    // Index of the currently selected record among the records being stepped through.
    function indexOfRecord(items, current) {
        if (!current) return -1;
        var uid = recordUid(current);
        for (var i = 0; i < items.length; i++) {
            if (recordUid(items[i]) === uid) return i;
        }
        return -1;
    }

    // The currently selected/current record, resolved from the .k-state-selected row.
    function getCurrentRecord(ginfo) {
        var $sel = ginfo.grid.find(".k-state-selected:not(span)").first();
        if ($sel.length) {
            var item = XPortal.Grid.GetGridDataRowItem(ginfo, $sel);
            if (item) return item;
        }
        // Fallback: the record the detail block currently shows (data-pid = UniqueId). data-pid
        // outlives the record it was showing - it survives the detail being cleared, and by a
        // filter that drops the record - so only trust it while the detail form is on screen.
        var $detail = ginfo.grid.closest(".tab-pane, body")
            .find(".detailblock-viewcontainer[data-src='#" + ginfo.grid.attr("id") + "'][data-pid]").first();
        if ($detail.find(".selection-frm").first().hasClass("d-none")) return null;

        var pid = $detail.attr("data-pid");
        if (!pid) return null;

        var data = flattenGroups(ginfo.kgrid.dataSource.data().slice());
        for (var i = 0; i < data.length; i++) {
            if (XPortal.Grid.DataUniqueId(data[i]) === pid) return data[i];
        }
        return null;
    }

    function getPageCount(ds) {
        var total = ds.total();
        var pageSize = ds.pageSize();
        if (!pageSize || pageSize >= total) return 1;
        return Math.ceil(total / pageSize);
    }

    function findGrid($nav) {
        var $scope = $nav.closest(".tab-pane, body");
        var $section = $nav.closest("section.xsection");

        var parentId = $section.attr("data-parentid");
        var $parentGrid = parentId ? $scope.find("#entity-grid-" + parentId) : $();
        if ($parentGrid.length) return $parentGrid;

        while ($section.length && $.contains($scope[0], $section[0])) {
            var $g = $section.find(".entity-grid").first();
            if ($g.length) return $g;
            $section = $section.parent().closest("section.xsection");
        }
        return $scope.find(".entity-grid").first();
    }

    return self;
}());
